import { render } from "./contact.vue?vue&type=template&id=60b7edc2&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=60b7edc2&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b7edc2"]])

export default __exports__